import { Middleware, ActionPointInfo, IActionPointInfo } from '@tencent/workbench';
import { BaseAddonService } from '@framework/workbench/common/service/base-addon-service';

@Middleware()
export class AddonToolbarMiddleware {
    // 中间件会被触发多次，增加 loading 防止请求多次触发
    private loadingMap: {[key: string]: boolean} = {};

    public constructor(private readonly baseAddonService: BaseAddonService) {}

    public async use(@ActionPointInfo() info: IActionPointInfo) {
        const { name } = info;
        if (this.loadingMap[name]) {
            return;
        }
        this.loadingMap[name] = true;
        try {
            await this.baseAddonService.toolbarButtonHandles.get(name)?.();
        } catch (error) {
            this.loadingMap[name] = false;
            window.log?.error(error);
        }
        this.loadingMap[name] = false;
    }
}
